import { GoogleAddressLookupProps } from 'react-rainbow-components/components/GoogleAddressLookup';
import { StyledGoogleAddressLookup } from './styled';
import { GOOGLE_MAPS_API_KEY } from '../../constants';

const GoogleAddressLookup = (props: Omit<GoogleAddressLookupProps, 'apiKey'>) => (
    <StyledGoogleAddressLookup {...props} apiKey={GOOGLE_MAPS_API_KEY} />
);

export default GoogleAddressLookup;
